import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
import create from "../../create";
export default create({
  name: "funnel",
  computed: {
    x2: function x2() {
      return this.option.gridX2 || 20;
    },
    fontSize: function fontSize() {
      return this.option.fontSize || 14;
    }
  },
  methods: {
    updateChart: function updateChart() {
      var _this = this;

      var optionData = this.deepClone(this.dataChart);
      var option = {
        title: this.ishasprop(this.option.titleShow, {
          text: this.option.title,
          subtext: this.option.subtext || '',
          textStyle: {
            color: this.option.titleColor || '#333',
            fontSize: this.option.titleFontSize || 16
          },
          left: this.option.titlePostion || 'auto',
          subtextStyle: {
            color: this.option.subTitleColor || '#aaa',
            fontSize: this.option.subTitleFontSize || 14
          }
        }, {}),
        tooltip: this.ishasprop(this.formatter, {
          formatter: function formatter(name) {
            return _this.formatter(name, _this.dataChart);
          }
        }, {
          backgroundColor: this.option.tipBackgroundColor || 'rgba(50,50,50,0.7)',
          textStyle: {
            fontSize: this.option.tipFontSize,
            color: this.option.tipColor || "#fff"
          }
        }),
        grid: {
          left: this.option.gridX || 20,
          top: this.option.gridY || 60,
          right: this.x2,
          bottom: this.option.gridY2 || 60
        },
        legend: {
          show: this.vaildData(this.option.legend, false),
          orient: this.option.legendOrient || "horizontal",
          top: 0,
          x: this.option.legendPostion || "right",
          right: this.x2,
          textStyle: {
            fontSize: this.option.legendFontSize || 12
          },
          data: function () {
            return (Array.isArray(optionData) ? optionData : []).map(function (ele, index) {
              return ele.name;
            });
          }()
        },
        series: function () {
          var barColor = _this.option.barColor || [];
          var list = [{
            type: "funnel",
            animationDelay: function animationDelay(idx) {
              return Math.random() * 200;
            },
            label: {
              show: _this.vaildData(_this.option.labelShow, false),
              fontSize: _this.fontSize
            },
            data: function () {
              var list = optionData;

              if (_this.option.notCount) {
                list = list.filter(function (ele) {
                  if (ele.value !== 0 && ele.value) {
                    return true;
                  }
                });
              }

              if (_this.option.sort) {
                list.sort(function (a, b) {
                  return a.value - b.value;
                });
              }

              return list;
            }(),
            itemStyle: _this.ishasprop(!_this.switchTheme, {
              normal: {
                color: function color(params) {
                  return _this.getColor(params.dataIndex);
                }
              }
            }, {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            })
          }];
          return list;
        }()
      };
      this.myChart.resize();
      this.myChart.setOption(option, true);
    }
  }
});